import { object, string } from "yup";

export const userFilterSchema = object({
    userName: string()
        .required("Kullanıcı Adı zorunludur")
        .max(100, "Kullanıcı Adı 100 karakterden uzun olamaz")
        .nullable(),
    userDesc: string()
        .max(100, "Kullanıcı Açıklaması 100 karakterden uzun olamaz")
        .nullable(),
    userPassword: string()
        .required("Kullanıcı şifresi zorunludur.")
        .min(6, "Kullanıcı şifresi 6 karakterden uzun olmalıdır.")
        .max(50, "Kullanıcı şifresi 50 karakterden fazla olamaz.")
        .nullable(),
    userCode: string()
        .max(50, "Kullanıcı Kodu 50 karakterden uzun olamaz")
        .nullable(),
    userEmail: string()
        .max(150, "E-Posta adresi 150 karakterden uzun olamaz")
        .required("Lütfen E-Posta adresini giriniz")
        .email("Lütfen E-Posta adresini doğru formatta giriniz")
        .nullable(),
    userPhone: string()
        .required("Telefon numarası zorunludur")
        .test(
        "phone-format",
        "Lütfen telefon numarasını doğru formatta giriniz",
        function (value) {
            if (!value) return true;
            if (value.startsWith("0")) {
            return /^0\d{10}$/.test(value);
            }
            return true;
        }
        ),
    userType: string()
        .required("Kullanıcı Tipi zorunludur"),
    erpSalesmanCode: string()
        .max(50, "ERP Satış Temsilcisi Kodu 50 karakterden uzun olamaz")
        .nullable(),
});